// extracted by mini-css-extract-plugin
module.exports = {"container":"notfound404_container__1KEoT","icon":"notfound404_icon__3qJl-","title":"notfound404_title__2E3cp"};